module.exports = __webpack_public_path__ + "img/happy-1.b6ab6326.png";